import styled from 'styled-components';

import { Heading } from 'Components/Table/Table.styled';

export const Wrapper = styled.div`
    ${Heading} {
        margin-top: 1.5rem;
    }
`;
